var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.8516 19.4531C21.1148 19.4531 19.5843 20.3075 18.623 21.6067L10.3119 17.351C10.4499 16.8807 10.5469 16.3932 10.5469 15.8789C10.5469 15.1813 10.4038 14.5181 10.1568 13.908L18.8547 8.67398C19.8227 9.81 21.2454 10.5469 22.8516 10.5469C25.7595 10.5469 28.125 8.18139 28.125 5.27344C28.125 2.36549 25.7595 0 22.8516 0C19.9436 0 17.5781 2.36549 17.5781 5.27344C17.5781 5.94357 17.7161 6.57926 17.945 7.16941L9.22119 12.4188C8.25404 11.3166 6.85178 10.6055 5.27344 10.6055C2.36549 10.6055 0 12.971 0 15.8789C0 18.7869 2.36549 21.1523 5.27344 21.1523C7.03887 21.1523 8.59518 20.2729 9.55283 18.9371L17.8366 23.179C17.684 23.6716 17.5781 24.1846 17.5781 24.7266C17.5781 27.6345 19.9436 30 22.8516 30C25.7595 30 28.125 27.6345 28.125 24.7266C28.125 21.8186 25.7595 19.4531 22.8516 19.4531Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareTransparent);
export default __webpack_public_path__ + "static/media/shareTransparent.9b204deb0f6fa4718f7045a547bea6ca.svg";
export { ForwardRef as ReactComponent };